module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_diamonds-2.6655152b.svg";